import React from "react";
import { Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  const navItems = [
    { label: "Home", to: "/" },
    { label: "About", to: "#about" },
    { label: "How to Use", to: "#how" },
    { label: "Privacy Policy", to: "/privacy" }, // Updated to use route
  ];

  return (
    <footer className="bg-gradient-to-t from-indigo-50 dark:from-gray-900/50 to-white dark:to-gray-900/80 border-t border-slate-200/50 dark:border-gray-700/50 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-center justify-between gap-6">
        {/* Logo */}
        <div className="flex items-center gap-2 text-xl font-bold text-slate-900 dark:text-white">
          <Sparkles className="w-6 h-6 text-indigo-500" />
          QuickCaptionIO
        </div>

        {/* Links */}
        <nav className="flex gap-6 flex-wrap justify-center">
          {navItems.map((item) =>
            item.to.startsWith("/") ? (
              <Link
                key={item.label}
                to={item.to}
                className="text-slate-700 dark:text-slate-300 hover:text-indigo-500 dark:hover:text-indigo-400 transition"
              >
                {item.label}
              </Link>
            ) : (
              <a
                key={item.label}
                href={item.to}
                className="text-slate-700 dark:text-slate-300 hover:text-indigo-500 dark:hover:text-indigo-400 transition"
              >
                {item.label}
              </a>
            )
          )}
        </nav>

        {/* Japanese Language Button */}
        <div className="mt-4 md:mt-0">
          <Link
            to="/japanese"
            className="text-indigo-500 font-semibold hover:underline"
          >
            日本語
          </Link>
        </div>

        {/* Copyright */}
        <p className="text-slate-500 dark:text-slate-400 text-sm text-center md:text-left mt-4 md:mt-0">
          &copy; {new Date().getFullYear()} QuickCaptionIO. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
